import { Category } from '@/prisma/utils/categories';
import { Checkbox } from '@chakra-ui/checkbox';
import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { SimpleGrid } from '@chakra-ui/layout';
import { ChangeEvent, useEffect, useState } from 'react';

type CategorySelectControlProps = {
	categories: Category[];
	selectedCategories?: Category[];
	onCategoriesChange: (categories: Category[]) => void;
};

const CategorySelectControl: React.FC<CategorySelectControlProps> = ({
	onCategoriesChange,
	...props
}) => {
	const [selectedCategories, setSelectedCategories] = useState<Category[]>(
		props.selectedCategories || []
	);

	const handleCategoryCheckboxChange = (
		category: Category,
		e: ChangeEvent<HTMLInputElement>
	) => {
		const target = e.target as HTMLInputElement;

		if (target.checked) {
			setSelectedCategories([...selectedCategories, category]);
		} else {
			setSelectedCategories(
				selectedCategories.filter((c) => c.id !== category.id)
			);
		}
	};

	useEffect(() => {
		onCategoriesChange(selectedCategories);
	}, [onCategoriesChange, selectedCategories]);

	return (
		<FormControl mt={4}>
			<FormLabel>Categories</FormLabel>
			<SimpleGrid
				spacing={2}
				columns={2}
			>
				{props.categories.map((_c) => (
					<Checkbox
						key={_c.id}
						value={_c.id}
						css={{
							alignItems: 'start',
							lineHeight: 1,
						}}
						isChecked={!!selectedCategories.find((c) => _c.id === c.id)}
						onChange={(e) => handleCategoryCheckboxChange(_c, e)}
					>
						{_c.name}
					</Checkbox>
				))}
			</SimpleGrid>
		</FormControl>
	);
};

export default CategorySelectControl;
